// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0e395ab4","239":"fe58b77e","667":"9c922e76"}[chunkId] + ".chunk.js";
};